import { createAction } from 'helpers/actionHelpers/createAction'

export type ErrorPayload = {
  errorCode: number
  errorExtra?: string[]
  errorsMap?: Record<string, string[]>
}

const createRequestMeta = <T, P, M>(actionType: T, actionMeta: M) => {
  return class extends createAction<T, P>(actionType) {
    meta: M

    constructor (payload: P) {
      super(payload)
      this.meta = actionMeta
    }
  }
}

export const createRequestAction = <T, Req, Res, ErrPayload = ErrorPayload>(actionType: T) => {
  class ResponseAction extends createRequestMeta<T, { params: Req, response: Res }, 'success'>(actionType, 'success') {}
  class FailAction extends createRequestMeta<T, { params: Req } & ErrPayload, 'fail'>(actionType, 'fail') {
    error: true
  }

  return class RequestAction extends createRequestMeta<T, { params: Req }, 'request'>(actionType, 'request') {
    static Type: RequestAction | ResponseAction | FailAction
    static type = actionType
    type = actionType

    constructor (params: Req) {
      super({ params })
    }

    success = (response: Res) => {
      return new ResponseAction({
        params: this.payload.params,
        response,
      })
    }

    fail = (error: ErrPayload) => {
      return new FailAction({
        params: this.payload.params,
        ...error,
      })
    }

  }
}
